import { render, staticRenderFns } from "./CopyConfigDialog.vue?vue&type=template&id=de4dc96a"
import script from "./CopyConfigDialog.vue?vue&type=script&lang=js"
export * from "./CopyConfigDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports